const firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_CLIENT_CONFIG);

export default firebaseConfig;
